export default __webpack_public_path__ + "static/media/age_6_background_desktop.906a3f3a.png";